import { createAsyncThunk, createSlice, createAction } from '@reduxjs/toolkit'

import moment from 'moment/moment'
import { ToastCtl } from '../../../../components/custom/toast/ToastCtl'
import { ApiService } from '../../../../../utility/api.service'

export const fetchDevices = createAsyncThunk('devices/fetchAll', async ({ filter = null, fields = null, offset = 0, limit = 250, sort, begin = null, end = null }) => {
    const query = new URLSearchParams({
        filter: filter ? JSON.stringify(filter) : '',
        fields: fields ? JSON.stringify(fields) : '',
        offset,
        limit,
        sort: sort ? JSON.stringify(sort) : '',
    });
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/devices/${begin}/${end}/?${query}`)
    return { devices: Object.values(response.data), count: response.count }
})

export const fetchDevice = createAsyncThunk('device/fetch', async ({ begin, end, id }) => {
    if (!begin) {
        begin = moment()
    }

    if (!end) {
        end = moment()
    }

    if (!id) {
        return
    }

    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/device_data/${begin}/${end}/${id}`)
    return { devices: response.data }
})

export const updateDevice = createAsyncThunk('device/update', async ({ id, payload }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/device/${id}`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { device: response.data.device }
})

export const createDevice = createAsyncThunk('device/create', async ({ payload }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/device`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { device: response.data.device }
})


const initialState = {
    devices: [],
    selectedDevice: null,
    loading: false,
    submitting: false,
    error: null,
    count: 0
}

const deviceSlice = createSlice({
    name: 'devices',
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
        reset: () => initialState
    },
    extraReducers: {
        [fetchDevices.pending]: (state) => {
            state.loading = true
        },
        [fetchDevices.fulfilled]: (state, { payload }) => {
            state.devices = payload.devices
            state.count = payload.count
            state.loading = false
        },
        [fetchDevices.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [fetchDevice.pending]: (state) => {
            state.loading = true
        },
        [fetchDevice.fulfilled]: (state, { payload }) => {
            if (payload?.devices?.length === 1) {
                state.selectedDevice = payload.devices[0]
            } else {
                state.devices = payload?.devices
            }

            state.loading = false
        },
        [fetchDevice.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [updateDevice.pending]: (state) => {
            state.submitting = true
        },
        [updateDevice.fulfilled]: (state, { payload }) => {
            state.selectedDevice = payload.device
            state.submitting = false

            ToastCtl.success('Daten wurden erfolgreich gespeichert')
        },
        [updateDevice.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly

            ToastCtl.error('Daten konnten nicht gespeichert werden')
        },

        [createDevice.pending]: (state) => {
            state.submitting = true
        },
        [createDevice.fulfilled]: (state, { payload }) => {
            state.selectedDevice = payload.device
            state.submitting = false
        },
        [createDevice.rejected]: (state, action) => {
            state.submitting = false
            state.error = action
        }
    }
})

export const { reset } = deviceSlice.actions
export default deviceSlice.reducer